import React from 'react';
import { useNavigate } from "react-router-dom";

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/plugin/utc'


import Select from '@mui/material/Select';
import {
    Box,
    TextField,
    FormControl,
    Typography,
    InputLabel,
    MenuItem,
    Divider,
    InputAdornment,
    IconButton,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import cl from '../static/style.module.css'

import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';

import { creatURLGoogleMap, iconColors, Sources, capitalizeFirstLetter } from '../helpers/scripts'
import { getCountry } from '../helpers/requests'

const copyFieldValue = (value) => {
    const text = value == null ? '' : String(value)
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
    }
}

const CopyField = ({ value, label, ...props }) => (
    <TextField
        {...props}
        label={label}
        value={value}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        size="small"
                        edge="end"
                        aria-label={`Скопировать ${label}`}
                        onClick={() => copyFieldValue(value)}
                    >
                        <ContentCopyIcon sx={{ fontSize: 16, color: '#7f7f7f' }} />
                    </IconButton>
                </InputAdornment>
            ),
        }}
    />
)

const ModuleOrder = ({ order, updateOrder, setOrder }) => {

    const sxMT = { mt: 2 }
    const page = 'order'

    const navigate = useNavigate()

    const checkCountry = async ()  => {
        let q =[]
        if (order.address.city) {
            q.push(order.address.city)
        }
        if (order.address.country) {
            q.push(order.address.country)
        }
        if (q.length){
            const rs = await getCountry(q)
            console.log(rs)
            if (rs && rs.country){
                setOrder( {...order, 'address':{...order.address, ['country']:rs.country, ['countryCode']:rs.countryCode} })

            }
           
        }
    }

    const formatLastNameAndFirstName = () => {

        if (setOrder){
            setOrder( {...order, 'user':{...order.user, ['lastName']:capitalizeFirstLetter(order.user.lastName), ['firstName']:capitalizeFirstLetter(order.user.firstName) } })

        }

    }

    const localUpdateOrder = (e)=>{
        if (updateOrder){
            updateOrder(e)
        }
    }



    return (

        <>
        
            <Divider sx={{ my: 2 }} />
            <div style={{ display: 'flex' }}>

                <div style={{ width: '200px', flex: 'left' }}>
                    <div style={{display:'flex'}}>
                        <Typography variant='subtitle1' color="initial" onDoubleClick={() => console.log(order)}>Детали заказа</Typography>
                        <LinkRoundedIcon 
                            sx={{ml:1, mt:'4px', cursor:'pointer', color:iconColors.blue}}
                            onClick={()=>{
                                navigate(`/orders/${order.id}`)
                            }}
                            /> 
                    </div>
                    

                    <Box style={{ display: 'grid' }}>

                        <TextField
                            name='date'
                            id='date'
                            onChange={(e) => localUpdateOrder(e)}
                            value={dayjs(order.date).format('YYYY-MM-DDTHH:mm:ss')} // "2018-06-12T19:30"
                            label="Дата"
                            type='datetime-local'
                            onDoubleClick={(e) => console.log(e.target.value)}
                            autoComplete=''
                            InputLabelProps={{ shrink: true }}
                            sx={sxMT}
                        />

                        <TextField
                            name='orderID'
                            id='orderID'
                            onChange={(e) => localUpdateOrder(e)}
                            value={order.orderID}
                            label="Номер заказа"
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}
                        />

                        <TextField
                            name='messageID'
                            id='messageID'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Gmail ID"
                            value={order.messageID || ''}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}

                        />

                        <FormControl sx={{ minWidth: '150px', ...sxMT }}
                            className={cl.mt20}>

                            <InputLabel id="source">Платформа</InputLabel>
                            <Select
                                labelId="ssource.code"
                                id="source.code"
                                name="source.code"
                                value={order.source.code}
                                label="Платформа"
                                onChange={(e) => localUpdateOrder(e)}
                                sx={{ fontSize: 'smaller' }}

                            >
                                {Object.values(Sources).map(i => <MenuItem key={i['code']} value={i['code']}> {i['name']} </MenuItem>)}

                            </Select>
                        </FormControl>


                    </Box>


                </div>


                <div style={{ width: '200px', marginLeft: '10px', flex: 'left', marginRight: 'auto' }}>

                    <Typography variant='subtitle1' color="initial" > |-- </Typography>

                    <Box style={{ display: 'grid' }}>

                        <TextField
                            name='totalQuantity'
                            id='totalQuantity'
                            onChange={(e) => localUpdateOrder(e)}
                            type={'number'}
                            label="Кол-во"
                            value={order.totalQuantity || 0}
                            InputLabelProps={{ shrink: true }}
                            sx={{ ...sxMT, fontSize: 'smaller' }}

                        />

                        <TextField
                            name='totalOrderPrice'
                            id='totalOrderPrice'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Сумма заказа"
                            value={order.totalOrderPrice || 0.0}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}
                        />


                        <FormControl sx={{ minWidth: '150px', ...sxMT }}
                            className={cl.mt20}>

                            <InputLabel id="isCancel">Заказ анулирован</InputLabel>
                            <Select
                                labelId="isCancel"
                                name="isCancel"
                                id="isCancel"
                                value={order.isCancel ? true : false}
                                label="Заказ анулирован"
                                onChange={(e) => localUpdateOrder(e)}
                                // InputLabelProps={{ shrink: order.isCancel }}  
                                sx={{ fontSize: 'smaller', }}
                            >
                                <MenuItem value={false}>Нет</MenuItem>
                                <MenuItem value={true}>Да</MenuItem>

                            </Select>
                        </FormControl>


                        <TextField
                            name='paymentType'
                            id='paymentType'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Способ оплаты"
                            value={order.paymentType || ''}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}

                        />

                    </Box>


                </div>



                < div style={{ marginRight: '20px', width: '200px', flex: 'right' }}>

                    <Typography variant='subtitle1' color="initial" >Клиент</Typography>

                    <div style={{ display: 'grid' }}>

                        <CopyField
                            name='user.nikename'
                            id='user.nikename'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Псевдоним"
                            value={order.user.nikename || ''}
                            sx={sxMT}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'

                        />

                        <CopyField
                            name='user.firstName'
                            id='user.firstName'
                            onChange={(e) => localUpdateOrder(e)}
                            onDoubleClick={formatLastNameAndFirstName}
                            label="Имя"
                            value={order.user.firstName || ''}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}

                        />
                        <CopyField
                            name='user.lastName'
                            id='user.lastName'
                            onChange={(e) => localUpdateOrder(e)}
                            onDoubleClick={formatLastNameAndFirstName}
                            label="Фамилия"
                            value={order.user.lastName || ''}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}

                        />
                        <CopyField
                            name='user.email'
                            id='user.email'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Email"
                            value={order.user.email || ''}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            sx={sxMT}

                        />


                    </div>


                </div>



                < div style={{ marginRight: '10px', width: '200px', flex: 'right' }}>

                    <Typography variant='subtitle1' color="initial" >Адрес доставки</Typography>

                    <div style={{ display: 'grid' }}>

                        <CopyField
                            name='user.phone'
                            id='user.phone'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Телефон"
                            value={order.user.phone || ''}
                            InputLabelProps={{ shrink: true, }}
                            autoComplete='off'
                            sx={sxMT}

                        />



                        <CopyField
                            name='address.street'
                            id='address.street'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Улица"
                            value={order.address.street || ''}
                            sx={sxMT}
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'

                        />

                        <CopyField
                            name='address.street_1'
                            id='address.street_1'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Улица 2"
                            value={order.address.street_1 || ''}
                            InputLabelProps={{ shrink: true }}
                            sx={sxMT}
                            autoComplete='off'

                        />
                        <CopyField
                            name='address.city'
                            id='address.city'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Город"
                            value={order.address.city || ''}
                            InputLabelProps={{ shrink: true }}
                            sx={sxMT}
                            autoComplete='off'

                        />


                    </div>


                </div>



                < div style={{ width: '200px', flex: 'right' }}>

                    <div style={{display:'flex', justifyContent:'space-between'}}>
                        <Typography variant='subtitle1' color="initial" > |-- </Typography>
                        <div>
                            <PublicOutlinedIcon sx={{ color: iconColors.grayDark, cursor:'pointer'}} onDoubleClick={() => creatURLGoogleMap(order.address)}/>
                            {/* <PublicOutlinedIcon sx={{ color: iconColors.grayDark}}/> */}
                        </div>

                    </div>

                    

                    <div style={{ display: 'grid' }}>


                        <CopyField
                            name='address.index'
                            id='address.index'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Индекс"
                            value={order.address.index || ''}
                            InputLabelProps={{ shrink: true }}
                            sx={sxMT}
                            autoComplete='off'

                        />
                        <CopyField
                            name='address.state'
                            id='address.state'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Регион"
                            value={order.address.state || ''}
                            InputLabelProps={{ shrink: true, }}
                            sx={sxMT}
                            autoComplete='off'

                        />
                        <CopyField
                            name='address.country'
                            id='address.country'
                            onChange={(e) => localUpdateOrder(e)}
                            onDoubleClick={()=>checkCountry()}
                            label="Страна"
                            value={order.address.country || ''}
                            InputLabelProps={{ shrink: true, }}
                            sx={sxMT}
                            autoComplete='off'

                        />
                        <CopyField
                            name='address.countryCode'
                            id='address.countryCode'
                            onChange={(e) => localUpdateOrder(e)}
                            label="Код страны"
                            value={order.address.countryCode || ''}
                            InputLabelProps={{ shrink: true, }}
                            sx={sxMT}
                            autoComplete='off'

                        />

                    </div>


                </div>

            </div>
        </>
    );
}

export default ModuleOrder;
